export default __webpack_public_path__ + "static/media/5.605ae3d2.png";